import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { Contacts } from "../WorkSpace/CanvasViewer/Canvas/CanvasGeneralStyles";
import WorkspaceContext from "../WorkSpace/WorkspaceContext";
import { rgbaToHex } from "./PickerAndSelector";
import { truncateWithEllipsis } from "../../services/Utils";
export const ContactsStyle = styled(Contacts)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-transform: lowercase;
  font-weight: bold;
  justify-items: center;
  align-items: center;
  ${({ canvasScale, styles }) => css`
    .logo-social-wrapper {
      color: ${rgbaToHex(styles.txtColor, 1)};
      border-radius: ${10 * canvasScale}px;
      line-height: 0.5;
      height: min-content;
      align-items: center;
    }
    justify-content: center;
    align-items: start;

    .qrcode {
      width: ${5 * canvasScale}rem;
      height: ${5 * canvasScale}rem;
      transform: translateX(${10 * canvasScale}px);
    }
  `}
`;

const SpanStyles = css`
  display: inline-block;
  line-height: 1.5;
  color: #ffffff;
  ${({ canvasScale }) => css`
    font-size: ${24 * canvasScale}px;
    padding: 0 ${8 * canvasScale}px 0 ${18 * canvasScale}px;
    border-radius: ${12 * canvasScale}px;
    border-bottom-right-radius: ${12 * canvasScale}px;
  `}
`;

const MediaSpan = styled.span`
  ${SpanStyles}
  ${({ media }) => css`
    ${media &&
    media === "instagram" &&
    `background: linear-gradient(to right, #833ab4, #405de6);`}
    ${media &&
    media === "whatsapp" &&
    `background: linear-gradient(to right, #25D366, #128C7E);`}
    ${media &&
    media === "facebook" &&
    `background: linear-gradient(to right, #3b5998, #192f6a);`}
      ${media &&
    media === "website" &&
    `background: linear-gradient(to right, #5958d0, #7f84ff);`}
  `}
`;

const Delivery = styled.div`
  align-items: center;
  justify-content: center;
  width: min-content;
  white-space: nowrap;
  ${({ canvasScale }) => css`
    .icon {
      background-image: url("images/delivery.png");
      width: ${4.5 * canvasScale}rem;
      height: ${4.5 * canvasScale}rem;
      background-size: cover;
      transform: translateX(${10 * canvasScale}px);
    }

    span {
      ${SpanStyles}
      text-transform: uppercase;
      font-size: ${20 * canvasScale}px;
      background: linear-gradient(to right, #c20713ff, #ac0914ff);
    }
  `}
`;
export const MediaIcon = styled.div`
  background-size: cover;
  ${({ canvasScale, icon }) => `
  transform: translateX(${15 * canvasScale}px);
    width:${4.5 * canvasScale}rem;
    height:${4.5 * canvasScale}rem;
    background-image: url(${icon});
    padding: ${1 * canvasScale}rem;
  `}
`;

export default function BrandContacts({
  styles,
  canvasScale,
  className,
  shouldLimitLength = true,
}) {
  const { userBrand } = useContext(WorkspaceContext);
  return (
    <>
      {userBrand && (
        <ContactsStyle
          styles={styles}
          canvasScale={canvasScale}
          className={className}
        >
          {userBrand.social.instagram != "" && (
            <div className="logo-social-wrapper flex">
              <MediaIcon
                className="media-icon"
                canvasScale={canvasScale}
                icon={"/icons/instagram_icon.png"}
              />
              <MediaSpan
                className="align media-span"
                media={"instagram"}
                canvasScale={canvasScale}
              >
                {shouldLimitLength
                  ? truncateWithEllipsis(userBrand.social.instagram, 18)
                  : userBrand.social.instagram}
              </MediaSpan>
            </div>
          )}

          {userBrand.social.whatsapp != "" && (
            <div className="logo-social-wrapper flex">
              <MediaIcon
                className="media-icon"
                canvasScale={canvasScale}
                icon={"/icons/whatsapp_icon.png"}
              />
              <MediaSpan
                className="align media-span"
                media={"whatsapp"}
                canvasScale={canvasScale}
              >
                {shouldLimitLength
                  ? truncateWithEllipsis(userBrand.social.whatsapp, 15)
                  : userBrand.social.whatsapp}
              </MediaSpan>
            </div>
          )}
          {userBrand.social.facebook != "" && (
            <div className="logo-social-wrapper flex">
              <MediaIcon
                className="media-icon"
                canvasScale={canvasScale}
                icon={"/icons/facebook_icon.png"}
              />
              <MediaSpan
                className="align media-span"
                media={"facebook"}
                canvasScale={canvasScale}
              >
                {shouldLimitLength
                  ? truncateWithEllipsis(userBrand.social.facebook, 18)
                  : userBrand.social.facebook}
              </MediaSpan>
            </div>
          )}
          {userBrand.deliveryAvailable && (
            <Delivery
              className="flex delivery"
              canvasScale={canvasScale}
              styles={styles}
            >
              <div className="icon"></div>
              <span>Fazemos Entrega</span>
            </Delivery>
          )}
        </ContactsStyle>
      )}
    </>
  );
}
